import { Avatar } from '@inflearn/ds-react';

export function AvatarImage({ src }: { src: string }) {
  return <Avatar w={90} h={90} radius="50%" alt="profile image" src={src} />;
}
